import { useEffect, useState } from "react";
import Filter from "../../components/Filter";
import LineGraph from "../../components/Inventory/lineGraph";
import InventoryTable from "../../components/InventoryTable";
import TragetInventoryGraph from "../../components/Inventory/targetInventoryGraph";
import { useLocation } from "react-router-dom";
import AgeingInventory from "../../components/Inventory/ageingGraph";
import downarrow from "../../assets/downarrowFilter.svg";
import uparrow from "../../assets/uparrowFilter.svg";
import PO_graph1 from "../../assets/PO_graph1.png";
import PO_graph2 from "../../assets/PO_graph2.png";
import AG_graph1 from "../../assets/AG_graph1.png";
import AG_graph2 from "../../assets/AG_graph2.png";

type AlertType = "PotentialOverstock" | "PotentialStockout" | "AgeingInventory" | "DevaluedInventory" | "default";

const InventoryAlert = () => {
    const location = useLocation();
    const [alertType, setAlertType] = useState<AlertType>(
        (new URLSearchParams(location.search).get("alert") as AlertType) || "default"
    );
    const [isToggleOn, setToggleOn] = useState(true);
    const [tableHeight, setTableHeight] = useState<number>(25);
    const [isVisible, setIsVisible] = useState<boolean>(true);

    const graphTitleMapping: Record<AlertType, { flag: number; title: string, image:string }[]> = {
        PotentialOverstock: [
            { flag: 1, title: "Inventory Trend vs Target Inventory (Qty)", image:PO_graph1 },
            { flag: 2, title: "Purchases vs Demand", image:PO_graph2 }
        ],
        PotentialStockout: [
            { flag: 1, title: "Inventory Trend vs Target Inventory (Qty)", image:PO_graph1  },
            { flag: 2, title: "Purchases vs Demand", image:PO_graph2  }
        ],
        AgeingInventory: [
            { flag: 1, title: "DistrictWise Inactive Age Breakdown", image:AG_graph1 },
            { flag: 2, title: "Inventory Details to explore Rebalancing Opportunities", image:AG_graph2 }
        ],
        DevaluedInventory: [
            { flag: 1, title: "DistrictWise Inactive Age Breakdown", image:AG_graph1 },
            { flag: 2, title: "Inventory Details to explore Rebalancing Opportunities", image:AG_graph2 }
        ],
        default: []
    };

    const handleToggle = () => {
        setToggleOn(!isToggleOn);
    };

    const filterShowHandler = () => {
        setIsVisible(!isVisible);
    }

    useEffect(() => {
        if(isVisible && isToggleOn)
            setTableHeight(26)
        else if(isVisible && !isToggleOn)
            setTableHeight(57)
        else if(!isVisible && isToggleOn)
            setTableHeight(33)
        else
            setTableHeight(66)
    },[isToggleOn,isVisible])

    useEffect(() => {
        setAlertType((new URLSearchParams(location.search).get("alert") as AlertType) || "default");
    }, [location.search]);

    return (
        <>
            <div className="relative">
            <Filter filterShowHandler={filterShowHandler} isVisible={isVisible}/>
            </div>
            {!isToggleOn && (
                <div className="bg-[#F1F1F1] px-[2%] py-[1.2vh] grid grid-cols-2 gap-x-10">
                    {graphTitleMapping[alertType]?.map((each) => {
                        return <div className="flex">
                            <div className="border-[1px] border-[#BEBEBE] flex rounded
                        items-center cursor-pointer bg-[#fff]">
                                <div className="bg-[#bebebe] rounded-l">
                                    <img className="rounded-l w-[8.5vw] h-full" src={each.image} alt={each.title} />
                                </div>
                                <p className="text-fs16 font-semibold p-2 py-[0]">{each.title}</p>
                            </div>
                        </div>
                    })}
                </div>
            )}
            {isToggleOn && (
                <div className="bg-[#F1F1F1] h-[40vh] flex px-[2%] py-3">
                    <div className="flex items-center justify-center gap-4 w-[100%]">
                        {alertType === "PotentialOverstock" && (
                            <>
                                <LineGraph flag={1} title="Inventory Trend vs Target Inventory (Qty)" />
                                <LineGraph flag={2} title="Purchases vs Demand" />
                            </>
                        )}
                        {alertType === "PotentialStockout" && (
                            <>
                                <TragetInventoryGraph flag={1} title="Inventory Trend vs Target Inventory (Qty)" />
                                <LineGraph flag={2} title="Purchases vs Demand" />
                            </>
                        )}
                        {alertType === "AgeingInventory" && (
                            <>
                                <AgeingInventory flag={1} title="District Wise Inactive Age Breakdown" />
                                <AgeingInventory flag={2} title="Rebalancing Opportunities within District" />
                            </>
                        )}
                         {alertType === "DevaluedInventory" && (
                            <>
                                <AgeingInventory flag={3} title="Overall Inventory Breakdown" />
                                <AgeingInventory flag={2} title="Rebalancing Opportunities within District" />
                            </>
                        )}
                    </div>
                </div>
            )}
            <div className="flex flex-col gap-1 flex-grow h-[36vh] relative">
                <div className="absolute flex left-2/4 z-[10] translate-x-[-50%] translate-y-[-50%] justify-center cursor-pointer" onClick={handleToggle}>
                    {isToggleOn ? <img className="w-[1.5vw]" src={uparrow} alt="upArrow" /> : <img className="w-[1.5vw]" src={downarrow} alt="downArrow" />}
                </div>
                <InventoryTable tableHeight={tableHeight}/>
            </div>
        </>
    );
};

export default InventoryAlert;
